import { render } from "./InstallButton.vue?vue&type=template&id=5632ecc4&scoped=true&ts=true"
import script from "./InstallButton.vue?vue&type=script&lang=ts"
export * from "./InstallButton.vue?vue&type=script&lang=ts"

import "./InstallButton.vue?vue&type=style&index=0&id=5632ecc4&lang=scss&scoped=true"

import exportComponent from "/Users/niitsumahiroyasu/Project/typerunner_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5632ecc4"]])

export default __exports__